import styled from '@emotion/styled';
import { User } from '@trinity/chat-components/components/icons/User.js';
import { ManageCookiePreferences } from '@trinity/chat-components/components/ManageCookiePreferences';
import { SettingsTitle } from './SettingsTitle';

export type SettingsAccountUser = {
  firstName?: string;
  lastName?: string;
  email?: string;
  photoUrl?: string;
};

type Props = {
  user: SettingsAccountUser;
};

export const SettingsAccountScreen = ({ user }: Props) => {
  const { firstName, lastName, email, photoUrl } = user;

  return (
    <Root>
      <SettingsTitle title="Account Information" />

      <AvatarWrapper>
        {photoUrl ? (
          <AvatarPhoto url={photoUrl} />
        ) : (
          <AvatarPlaceholder>
            <StyledUserIcon />
          </AvatarPlaceholder>
        )}
      </AvatarWrapper>

      <FieldList>
        <FieldItem>
          <FieldLabel>First Name</FieldLabel>
          <FieldValue>{firstName || '—'}</FieldValue>
        </FieldItem>

        <FieldItem>
          <FieldLabel>Last Name</FieldLabel>
          <FieldValue>{lastName || '—'}</FieldValue>
        </FieldItem>

        <FieldItem>
          <FieldLabel>Phone</FieldLabel>
          <FieldValue>Not Set</FieldValue>
        </FieldItem>

        <FieldItem>
          <FieldLabel>Email</FieldLabel>
          <FieldValue>{email || '—'}</FieldValue>
        </FieldItem>
      </FieldList>

      <StyledManageCookiePreferences />
    </Root>
  );
};

const Root = styled.div({
  display: 'flex',
  flexDirection: 'column',
});

const AvatarWrapper = styled.div({
  marginBottom: 28,
});

const AvatarPhoto = styled.div<{ url: string }>(({ url }) => ({
  width: 70,
  height: 70,
  borderRadius: '50%',
  backgroundImage: `url(${url})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
}));

const AvatarPlaceholder = styled.div({
  width: 70,
  height: 70,
  borderRadius: '50%',
  backgroundColor: 'var(--gray-l)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

const StyledUserIcon = styled(User)({
  width: 38,
  height: 38,
  color: 'var(--pri-01)',
});

const FieldList = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: 20,
  marginBottom: 32,
});

const FieldItem = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
});

const FieldLabel = styled.div({
  fontFamily: 'var(--font-semibold)',
  fontSize: 18,
  color: 'var(--black-l)',
  marginBottom: 5,
});

const FieldValue = styled.div({
  lineHeight: '20px',
  fontFamily: 'var(--font-reg)',
  color: 'var(--black)',
});

const StyledManageCookiePreferences = styled(ManageCookiePreferences)({
  background: 'none',
  border: 'none',
  padding: 0,
  fontSize: 14,
  fontFamily: 'var(--font-reg)',
  color: 'var(--hyperlink)',
  cursor: 'pointer',
  textDecoration: 'underline',
  textAlign: 'left',
  alignSelf: 'flex-start',

  '&:hover': {
    color: 'var(--pri-02)',
  },
});
